import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const HISTORY_REQUEST_URLS: generalConst = {
  BASE_URL: ROUTES.REQUESTHISTORY,
  DETAIL_HISTORY_REQUEST: `${ROUTES.REQUESTHISTORY}/detail`,
};

export const HISTORY_REQUEST_FORM_FILTER = "HystoryRequestFormFilter";

export const REQUEST_LIST_IDENTIFIER = "historyList";

export const CSV_REQUEST_LIST_IDENTIFIER = "csvReqList";

export const CSV_REQUEST_LOAD_IDENTIFIER = "csvReqLoad";

export const SELECTED_REQUEST_IDENTIFIER = "selectedRequest";

export const DETAIL_REQUEST_IDENTIFIER = "requestDetail";

export const DETAIL_REQUEST_LOADER_IDENTIFIER = "requestDetailLoader";

export const HISTORY_REQUEST_LOADER = "historyRequestLoader";

export const CALL_STATE_IDENTIFIER = "callStateIdentifier";

export const CALL_STATE_IDENTIFIER_SAVE = "callStateIdentifierSaveAttachments";

export const ACCEPTED_RETRY_STATUS = ["ERROR", "RETRY"];

export const UNACCEPTED_RETRY_TYPE = ["CHANGE_PASSWORD"];
